import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';

const SignOut = () => {
  const navigate = useNavigate();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const [isRedirecting, setIsRedirecting] = useState(false);
  
  console.log('authStatus in signout.js', authStatus);
  
  useEffect(() => {
    if (authStatus === 'unauthenticated' && !isRedirecting) {
      // Set a flag to prevent multiple redirects
      setIsRedirecting(true);
      
      // Add a delay to ensure auth state is fully updated before redirect
      setTimeout(() => {
        navigate('/auth/signin', { 
          state: { 
            forceRefresh: true,
            timestamp: Date.now() // Force new component instance
          },
          replace: true // Use replace to avoid back button issues
        });
      }, 500); // Slightly longer delay to ensure complete signout
    }
  }, [authStatus, navigate, isRedirecting]);
  
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '90vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <h1 style={{ fontSize: '20px' }}>Signing out...</h1>
    </div>
  );
};

export default SignOut;